export const reactIdleTimer = 14400000; // time in msec 14400000 = 4 hours
